/*
 * Copyright Evollis 2022
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */

/* Utils */
import { TENANTS } from "../../../constants"
import { loc } from "../../../core/utils"

/* Forms controls & validation */
import TextField from "../../../form/TextField"
import Bloc from "./Bloc"
import React from "react"
import { Col, Row } from "react-bootstrap"

export default function BankCoordinatesBloc(props) {
  const { tunnelData, blocFields, completedFields } = props
  const { clientPageConfiguration, tenant } = tunnelData
  const { company } = clientPageConfiguration
  const ibanLabel = tenant === TENANTS.BPLS ? loc`IBAN bpls` : loc`IBAN`
  const bankLabelBloc = tunnelData.tenant === TENANTS.BPLS ? loc`Company bank details` : loc`Bank`

  return (
    <Bloc hide={!company} name={bankLabelBloc} completedFields={completedFields} totalFieldsNumber={blocFields.length}>
      <div className="hard-shadow-white-block">
        <Row>
          <Col lg={12}>
            <TextField
              name="bankCoordinates.ownerName"
              label={loc`Bank account owner`}
              trimOnBlur={true}
              disabled={false}
            />
          </Col>
          <Col lg={12}>
            <TextField
              name="bankCoordinates.iban"
              label={ibanLabel}
              trimOnBlur={true}
              formatOnBlur={true}
              addIbanSeparator={true}
              disabled={false}
            />
          </Col>
        </Row>
      </div>
    </Bloc>
  )
}
